module.exports = __webpack_public_path__ + "images/66ee7409200351021b29f8e298a1601f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/logo.png
 ** module id = 874
 ** module chunks = 1
 **/